import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_ID, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { EagriModule } from '@mze/pds.mze.eagri.angular';
import { MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { CiselnikDropdownComponent } from './components/ciselnik-dropdown/ciselnik-dropdown.component';
import { CisenikInputComponent } from './components/cisenik-input/cisenik-input.component';
import { FormOznameniSberuComponent } from './components/form-oznameni-sberu/form-oznameni-sberu.component';
import { FormZadostPopOddilyComponent } from './components/form-zadost-pop-oddily/form-zadost-pop-oddily.component';
import { FormZadostPopComponent } from './components/form-zadost-pop/form-zadost-pop.component';
import { IsdsButtonComponent } from './components/isds-button/isds-button.component';
import { NaseptavacUjComponent } from './components/naseptavac-uj/naseptavac-uj.component';
import { PrefixedInputComponent } from './components/prefixed-input/prefixed-input.component';
import { PrintButtonComponent } from './components/print-button/print-button.component';
import { MessagesComponent } from './components/Shared/messages/messages.component';
import { CzechDatePipe } from './czech.datepipe';

@NgModule({
  declarations: [
    AppComponent,
    FormOznameniSberuComponent,
    FormZadostPopComponent,
    FormZadostPopOddilyComponent,
    FormZadostPopComponent,
    NaseptavacUjComponent,
    CisenikInputComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    DialogModule,
    BlockUIModule,
    MessagesModule,
    MessageModule,
    AutoCompleteModule,
    SelectModule,
    EagriModule,
    ProgressSpinnerModule,
    MessagesComponent,
    CiselnikDropdownComponent,
    PrintButtonComponent,
    IsdsButtonComponent,
    PrefixedInputComponent,
    CzechDatePipe,
    RouterModule.forRoot(routes)],
  providers: [
    { provide: LOCALE_ID, useValue: 'cs' },
    { provide: APP_ID, useValue: 'Zadosti' },
    ...appConfig.providers,
    MessageService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
